module.exports = __webpack_public_path__ + "static/media/5S.526b9687.svg";